<template>
    <div class="topbar-container">
        <zbView
            :isDisabledRefresh="true"
            @reLoad="userLoginend"
            emptyMessage="本车辆暂无违章信息"
            class="container break-list"
            :isEmpty="!info.total"
        >
            <div class="line"></div>
            <div class="bh tag-container">
                <div class="tag fz_28 r6">待处理{{info.total}}条</div>
                <div class="tag fz_28 r6">罚款{{info.totalFine}}元</div>
                <div class="tag fz_28 r6">扣分{{info.totalDegree}}分</div>
            </div>
            <div v-for="(item,i) in store" :key="i" class="list-item">
                <div class="line"></div>
                <div class="item">
                    <div class="bh bc fz_28 text-container">
                        <i class="icon ico-time-brerk bg-contain"></i>
                        <div class="b1">{{item.vioTime}}</div>
                        <span class="c_666">{{item.vioStatus}}</span>
                    </div>
                    <div class="fz_30 p24_0">{{item.vioLocation}}</div>
                    <div class="fz_24 c_666">{{item.vioReason}}</div>
                    <div class="pt30 fz_30 c_warning">罚款{{item.vioFine}}元&emsp;扣{{item.degree}}分</div>
                </div>
            </div>
            <div class="bh bstart warning-container fz_24 c_666">
                <van-icon name="warning-o" class="c_red" />长期不处理违章，将可能扣留驾驶证，严重时会扣车
            </div>
        </zbView>
        <div class="float-container radius bh bc">
            <van-button class="btn btn-text" @click="onHistoryClick">
                <div class="bg-contain ico-historyBtn"></div>
            </van-button>
        </div>
    </div>
</template>
<script>
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import zbView from "@/components/data/View";

export default {
    mixins: [user, routeCache],
    name: "BreakList",
    components: { zbView },
    data() {
        return {
            info: {},
            store: []
        };
    },
    methods: {
        userLoginend() {
            const me = this,
                params = me.getCache();
            me.$store.state.topBarTitle = params.name;
            me.setData(params.data);
        },
        setData(data) {
            const { list, ...info } = data;
            this.store = list;
            this.info = info;
        },
        onHistoryClick() {
            const { id } = this.getCache();
            this.go("BreakHistory", {
                id
            });
        }
    }
};
</script>
<style scoped lang="scss">
.float-container {
    border: none;
    .van-button--default {
        background-color: rgba(0, 0, 0, 0);
    }
    .ico-historyBtn {
        width: 100px;
        height: 100px;
    }
}
</style>